import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isToastElement(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest("[data-ui-toast]") !== null
}
